import { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom/dist";
import {
  getRemainingExpiration,
  resetExpiration,
} from "../../../utils/getOTPExpirationTime";
import EmailConfirmationStep from "./EmailConfirmationStep";
import OTPStep from "./OTPStep";
import ResetPasswordStep from "./ResetPasswordStep";

/**
 * The entry point of the forget password process.
 * It first shows a form asking the user for their email, once submitted, they get navigated into the OTP step to confirm the OTP that was sent to their email. Once confirmed, they get navigated into the reset password step to change their forgotten password.
 *
 * @returns {JSX.Element}
 */

const ForgetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [timer, setTimer] = useState(getRemainingExpiration());
  const { email, otpStep } = location.state || {};
  const currentEmail = searchParams.get("email");
  const prevEmailRef = useRef(email);
  // _________Rest OTP ON EMAIL CHANGE________//
  useEffect(() => {
    if (currentEmail && currentEmail !== prevEmailRef.current) {
      prevEmailRef.current = currentEmail;
      resetExpiration();
      setTimer(getRemainingExpiration());
    }
  }, [currentEmail]);

  useEffect(() => {
    if (email && !otpStep) {
      const handleBackButton = () => {
        // Clear location state without navigating away
        window.history.replaceState(null, "", location.pathname);
        navigate(location.pathname, { replace: true, state: {} });
      };

      window.addEventListener("popstate", handleBackButton);

      return () => {
        window.removeEventListener("popstate", handleBackButton);
      };
    }
  }, [navigate, location.pathname]);
  if (!email) {
    return <EmailConfirmationStep />;
  }
  if (otpStep) {
    return <OTPStep timer={timer} setTimer={setTimer} />;
  }
  return <ResetPasswordStep />;
};

export default ForgetPassword;
